import * as React from 'react';

import { IconProps } from '../Icon';

export const BeeFilledIcon = ({ width, color }: IconProps): JSX.Element => {
  const DEFAULT_WIDTH = '18';
  const DEFAULT_COLOR = 'none';

  return (
    <svg
      fill={color || DEFAULT_COLOR}
      height={width || DEFAULT_WIDTH}
      viewBox="0 0 512.081 512.08"
      width={width || DEFAULT_WIDTH}
      xmlns="http://www.w3.org/2000/svg"
    >
      <g>
        <path d="m500.797 293.509c-22.869-55.212-76.261-90.887-136.022-90.887-3.648 0-7.282.136-10.898.403-5.243 39.152 2.644 91.145 23.013 141.56 20.549 50.863 51.167 93.876 82.289 118.271 18.078-15.053 32.359-34.355 41.619-56.708 15.043-36.318 15.043-76.32-.001-112.639z" />
        <path d="m202.179 302.931c-9.09 12.563-17.708 26.157-25.776 40.706-26.314 47.453-37.722 88.373-38.194 90.092-1.82 6.617 1.083 13.625 7.049 17.018 3.019 1.716 62.221 34.947 136.396 47.068-21.114-25.48-39.815-57.276-54.189-92.857-13.958-34.541-22.529-69.607-25.286-102.027z" />
        <path d="m413.713 461.26c-25.764-28.076-48.116-64.536-64.64-105.438-16.378-40.536-25.618-81.962-26.719-119.799-.277-9.518-.033-18.643.716-27.326-4.912 1.461-9.77 3.176-14.56 5.16-27.528 11.402-53.364 29.485-76.861 53.744-2.352 37.025 6.009 82.508 23.63 126.117 18.032 44.639 44.05 83.502 71.985 108.402 2.026.043 4.056.073 6.091.073h.003c31.979 0 61.517-5.519 87.789-16.401 4.098-1.697 8.087-3.572 11.973-5.599-6.536-5.655-13.02-11.972-19.407-18.933z" />
        <path d="m268.325 183.248c-2.006-3.901-50.145-95.862-138.402-122.773-12.061-3.678-24.391-5.543-36.647-5.543-20.552 0-39.816 5.203-55.713 15.046-16.968 10.505-28.827 25.5-34.292 43.36-7.029 22.973-2.643 47.704 12.354 69.638 14.286 20.895 36.696 36.837 63.105 44.891 17.334 5.285 36.095 7.965 55.761 7.965h.002c67.716 0 125.305-31.252 127.723-32.582 7.114-3.915 9.822-12.78 6.109-20.002z" />
        <path d="m318.61 176.378c1.895 0 3.82-.361 5.679-1.123 2.463-1.009 60.558-25.303 81.558-77.555 13.93-34.659 1.468-72.446-27.777-84.231-5.896-2.378-12.146-3.584-18.575-3.584-24.913 0-48.933 18.112-59.769 45.07-21.001 52.248 4.085 110.056 5.163 112.491 2.473 5.59 7.957 8.932 13.721 8.932z" />
      </g>
    </svg>
  );
};
